import type {
  ButtonItem,
  HeadlineItem,
  SublineItem,
  TemplateWithPlainImagesFrame,
} from 'hb-builder/components/BuilderComponents/block/Strips/types/items';
import { createNewItem } from 'hb-builder/utils/createNewItem';
import type { StripItemChildAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/stripsItemAttributes';

const getNewElements = ({
  headline,
  subline,
  button,
  fields,
}: {
  headline: HeadlineItem;
  subline: SublineItem;
  button: ButtonItem;
  fields: StripItemChildAttributes['fields'];
}) => {
  const newHeadline = {
    ...headline,
    attributes: {
      ...headline.attributes,
      hidden: !fields.displayHeadline || false,
    },
  };

  const newSubline = {
    ...subline,
    attributes: {
      ...subline.attributes,
      hidden: !fields.displaySubline || false,
    },
  };

  const newButton = {
    ...button,
    attributes: {
      ...button.attributes,
      hidden: !fields.displayButton || false,
    },
  };

  return [newHeadline, newSubline, newButton];
};

export const getNewFrame = ({
  frame,
  fields,
}: {
  frame: TemplateWithPlainImagesFrame;
  fields: StripItemChildAttributes['fields'];
}) => {
  const [image, wrapper, button] = frame.children;
  const [headline, subline] = wrapper.children;
  const [newHeadline, newSubline, newButton] = getNewElements({
    headline,
    subline,
    button,
    fields,
  });

  const newWrapper = { ...wrapper, children: [newHeadline, newSubline] };

  return createNewItem({
    ...frame,
    children: [image, newWrapper, newButton],
  });
};
